import React, { useEffect, useState } from 'react';
import {
    Box,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Typography,
    Paper,
    Card, CardHeader,
    Avatar,
    Button, FormControl, Select, InputLabel, MenuItem, Switch,
    useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import Page from '../../components/Page';
import { useFormik, Form, FormikProvider, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import qs from 'qs'
import request from '../../components/request'
import { UpLoadInput, getHelperAndErrorProps, RichText } from '../MyComponents';
import { useOutletContext, useNavigate, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import DateRangePicker from '@mui/lab/DateRangePicker';
import DateTimePicker from '@mui/lab/DateTimePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import cnLocale from 'date-fns/locale/zh-CN';




const CSelect = (props) => {
    let { labelId, label, source } = props;

    let [data, setData] = useState([]);
    const loadData = async () => {
        var result = await request.GetData(source, {})
        if (result.Code === 1) {
            setData(result.Result.data);
        }
        else {

        }
    }

    useEffect(() => {
        loadData();
    }, [source])

    return (
        <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                {...props}
            >
                {data.map((item) => <MenuItem value={item.id}>{item.Name}</MenuItem>)}
            </Select>
        </FormControl>
    )
}


export default function Add() {
    const theme = useTheme();
    //console.log('theme', theme);
    const navigete = useNavigate();
    const [setTools] = useOutletContext();
    let { id } = useParams();
    let add = id === undefined;

    const loadData = async () => {
        var result = await request.GetData('Web/Office/ParkingSpace/ParkingSpaceTimeOne?id=' + id, {})
        if (result.Code === 1) {
            formik.setValues(result.Result);
        }
        else {
            global.addMessage(result.Message);
        }
    }
    useEffect(() => {
        if (!add) {
            setTools([
                {
                    title: '删除',
                    icon: 'carbon:delete',
                    onClick: async () => {
                        if (window.confirm('确定要删除吗？')) {
                            const result = await request.PostJsonData('Web/Office/ParkingSpace/DeleteParkingSpaceTime?id=' + id, {});
                            if (result.Code === 1) {
                                global.addMessage(result.Message);
                                global.myHistory.back();
                                return true;
                            }
                            else
                                global.addMessage(result.Message);
                            return false;
                        }
                    },
                }
            ]);
            loadData();
        }
    }, [])

    const LoginSchema = Yup.object().shape({
        StartTime: Yup.date().required('开始时间 必填').nullable(),
        EndTime: Yup.date().required('结束时间 必填').nullable(),
        EveryDay: Yup.boolean(),
        Open: Yup.boolean(),
    });

    const formik = useFormik({
        initialValues: {
            StartTime: null,
            EndTime: null,
            EveryDay: true,
            Open: true,
        },
        validationSchema: LoginSchema,
        onSubmit: (values, actions) => {
            actions.setSubmitting(true);
            //验证
            console.log('values', JSON.stringify(values));
            submit(values).then(result => {
                //if (!result) {
                actions.setSubmitting(false);
                //}
            })
        }
    });

    const submit = async (values) => {
        const data = values;
        const result = add ?
            await request.PostJsonData('Web/Office/ParkingSpace/CreateParkingSpaceTime', data) :
            await request.PostJsonData('Web/Office/ParkingSpace/UpdateParkingSpaceTime?id=' + id, data);
        if (result.Code === 1) {
            global.addMessage(result.Message);
            //navigete('/dashboard/ParkingSpace/list', { replace: true });
            global.myHistory.back();
            return true;
        }
        else
            global.addMessage(result.Message);

        return false;
    }

    const { errors, touched, values, isSubmitting, handleChange, handleSubmit, getFieldProps, setFieldValue } = formik;
    //console.log('formik', formik)
    //console.log('touched', touched)

    return (
        <Card>
            <Box p={3}>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Stack spacing={3} alignItems={'flex-start'}>

                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={cnLocale}>
                                {/* <DateRangePicker
                                    startText="开始时间"
                                    endText="结束时间"
                                    value={[values.StartTime, values.EndTime]}
                                    onChange={(newValue) => {
                                        console.log('DateRangePicker', newValue);
                                        try {
                                            setFieldValue('StartTime', newValue[0].Format('yyyy-MM-dd HH:mm:ss'));
                                            setFieldValue('EndTime', newValue[1].Format('yyyy-MM-dd HH:mm:ss'));
                                        } catch (e) { }
                                    }}
                                    renderInput={(startProps, endProps) => (
                                        <React.Fragment>
                                            <TextField {...startProps}
                                                {...getFieldProps('StartTime')}
                                                {...getHelperAndErrorProps(formik, 'StartTime')}
                                            />
                                            <Box sx={{ mx: 2 }}> 到 </Box>
                                            <TextField {...endProps}
                                                {...getFieldProps('EndTime')}
                                                {...getHelperAndErrorProps(formik, 'EndTime')}
                                            />
                                        </React.Fragment>
                                    )}
                                /> */}
                                <Stack direction={'row'} alignItems={'center'}>
                                    <DateTimePicker
                                        renderInput={(props) => <TextField {...props}
                                            {...getFieldProps('StartTime')}
                                            {...getHelperAndErrorProps(formik, 'StartTime')}
                                        />}
                                        label="开始时间"
                                        ampm={false} 
                                        value={values.StartTime}
                                        onChange={(newValue) => {
                                            try {
                                                console.log('newValue', newValue);
                                                setFieldValue('StartTime', newValue.Format('yyyy-MM-dd hh:mm:ss'));
                                            } catch (e) { }
                                        }}
                                    />
                                    <Box sx={{ mx: 2 }}> 到 </Box>
                                    <DateTimePicker
                                        renderInput={(props) => <TextField {...props}
                                            {...getFieldProps('EndTime')}
                                            {...getHelperAndErrorProps(formik, 'EndTime')}
                                        />}
                                        label="结束时间"
                                        ampm={false} 
                                        value={values.EndTime}
                                        onChange={(newValue) => {
                                            try {
                                                console.log('newValue', newValue);
                                                setFieldValue('EndTime', newValue.Format('yyyy-MM-dd hh:mm:ss'));
                                            } catch (e) { }
                                        }}
                                    />
                                </Stack>
                            </LocalizationProvider>

                            <FormControlLabel
                                control={
                                    <Switch
                                        name='EveryDay'
                                        color="primary"
                                        checked={values.EveryDay}
                                        onChange={handleChange}
                                    />
                                }
                                label="每天"
                                labelPlacement="end"

                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        name='Open'
                                        color="primary"
                                        checked={values.Open}
                                        onChange={handleChange}
                                    />
                                }
                                label="开启"
                                labelPlacement="end"
                            />



                            <Stack sx={{ my: 4 }}></Stack>

                            <LoadingButton

                                size="large"
                                type="submit"
                                variant="contained"
                                loading={isSubmitting}
                            >
                                保存
                            </LoadingButton>
                        </Stack>
                    </Form>
                </FormikProvider>
            </Box>
        </Card >
    );
}
